///<reference path="../api.d.ts" />
///<reference path="../../../shared/address/address-controller.ts" />

module agencyRegistration.controller {

    import material = angular.material;
    
    interface AssociateIScope extends ng.IScope {
        $createLoader: common.Loader;
    }
    
    export class AssociateController {
        // Dependencies
        createService: agencyRegistration.service.CreateService;
        $mdDialog: material.MDDialogService;
        stateService: angular.ui.IStateService;
        $rootScope: AssociateIScope;
        agentFactory: agencyRegistration.factory.agentFactory;
        
        // Properties
        fieldOptions: any;
        agency: API.Client.AgencyModel;
        loader : common.Loader = new common.Loader(); 
        alert: common.AlertMessage;
        
        /*@ngInject*/
        constructor(
            $rootScope: AssociateIScope,
            $state: angular.ui.IStateService, 
            agentFactory: agencyRegistration.factory.agentFactory, 
            createService: agencyRegistration.service.CreateService,
            $mdDialog: material.MDDialogService 
        ) { 
            // Dependencies
            this.createService = createService;
            this.$mdDialog = $mdDialog;
            this.stateService = $state;
            this.$rootScope = $rootScope;
            this.agentFactory = agentFactory;
            
            // Properties
            this.agency = agentFactory.getAgency();
            this.alert = new common.AlertMessage($mdDialog);
            
            // Get Fields
            createService.getFields().then(fields => {
                this.fieldOptions = fields;
            });
        };
        
        showLoaders(): void {
            this.$rootScope.$createLoader.showLoader("Salvando dados da agência...");
            this.loader.showLoader("Salvando dados da agência...");
        };
        
        hideLoaders(): void {
            this.$rootScope.$createLoader.hide();
            this.loader.hide();
        };
        
        cancel(): void {
          this.agentFactory.setNewAgency();
          this.stateService.go("search");
        };
        
        saveAgent(form: ng.IFormController, agency: API.Client.AgencyModel): void {
            form.$submitted = true;
            
            if (form.$valid) {
                this.showLoaders();
                
                // Loader Test
                setTimeout(() => {
                    this.createService.createAgency(agency).then(response => {
                        if (response["agencyPersonCode"]){
                            this.stateService.go("success", { agency: this.agency });
                        }
                        else {
                            this.alert.show({ content: response["error"]["message"] });
                        }
                    }).finally(() => { this.hideLoaders(); });
                }, 1500);
            }
        };
        
        addPartnerItem() {
            if (this.agency.partners.length < 5)
                this.agency.partners.push({ personType: 'F' });
        };
        
        removePartnerItem(item: API.Client.PartnerModel) {
            let index = this.agency.partners.indexOf(item);
            this.agency.partners.splice(index, 1);
        };
    }
}

angular.module('agencyRegistrationApp').controller('AssociateController', agencyRegistration.controller.AssociateController);
